import React from 'react'
import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import strings from '../../utils/Localization'

export default function KayitOlButton() {
    const navigate= useNavigate()

    return (
        <Button
            onClick={() => navigate('/KayitOl')}
            type="default"
            block size="middle"
        >{strings.girisYap.components.kayitOlButton.butonYazi}
        </Button>
    )
}
